import { useSyncExternalStore } from 'react';

/**
 * Situação do modal de avisos, para outros avisos automáticos não abrirem por cima dele.
 *
 * O modal vive no DashboardLayout e o tour de Produtos V2 dentro da página: sem ancestral comum
 * prático, o estado fica num store de módulo. `pending` cobre o intervalo em que ainda não dá para
 * saber se o modal abre (usuário carregando); se o tour abrisse nesse intervalo, o modal cairia por
 * cima dele.
 */
export const ANNOUNCEMENT_STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  OPEN: 'open',
};

let status = ANNOUNCEMENT_STATUS.IDLE;
const listeners = new Set();

export function setAnnouncementStatus(next) {
  if (next === status) return;
  status = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const getSnapshot = () => status;

export function useAnnouncementStatus() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

/** Verdadeiro enquanto o modal está aberto ou ainda pode abrir. */
export function useIsAnnouncementBlocking() {
  return useAnnouncementStatus() !== ANNOUNCEMENT_STATUS.IDLE;
}
